<template>
  <div>
    <v-flex xs12>
      <v-flex xs12>
        <v-card>
          <v-toolbar card prominent>
            <v-toolbar-title>Thông tin tài khoản</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu offset-y>
              <v-btn slot="activator" icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="isEdit = true">
                  <v-list-tile-title>Chỉnh sửa thông tin</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="changePasswordDialog = true">
                  <v-list-tile-title>Đổi mật khẩu</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="logout()">
                  <v-list-tile-title>Đăng xuất</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <v-btn icon>
              <v-icon @click="close()">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-form class="form-content" v-model="formValid" ref="form">
              <v-text-field
                prepend-icon="person"
                :disabled="!isEdit"
                v-model="form.name"
                :rules="[validate.required]"
              ></v-text-field>
              <v-text-field prepend-icon="phone" disabled v-model="form.phone"></v-text-field>
              <v-text-field
                prepend-icon="email"
                :disabled="!isEdit"
                v-model="form.email"
                :rules="[validate.required, validate.email]"
              ></v-text-field>
              <v-text-field prepend-icon="place" :disabled="!isEdit" v-model="form.address"></v-text-field>
              <div class="right" v-show="isEdit">
                <v-btn flat @click="isEdit = false">Hủy</v-btn>
                <v-btn color="success" @click="submit()" :loading="isLoading">Cập nhật</v-btn>
              </div>
              <div class="clear"></div>
              <div class="text-xs-center">
                <v-chip class="btn-link justify-center" color="grey lighten-4" label @click="openDialogConfirmCancel('google')" v-if="linkGoogle">
                  <img src="/static/icons/icon-google-normal.png" class="btn-icon">
                  <span class="pl-2 pr-2 text-uppercase body-2">Đã liên kết tài khoản với Google</span>
                  <v-icon color="green">check</v-icon>
                </v-chip>
                <v-btn id="signInGoogle" class="btn-link" :loading="loadingGoogle" depressed href="" v-else>
                  <img src="/static/icons/icon-google-normal.png" class="btn-icon">
                  <span class="pl-2">Liên kết tài khoản với Google</span>
                </v-btn>

                <v-chip class="btn-link justify-center" color="grey lighten-4" label depressed @click="openDialogConfirmCancel('facebook')" v-if="linkFacebook">
                  <img src="/static/icons/icon-facebook.png" class="btn-icon">
                  <span class="pl-2 pr-2 text-uppercase body-2">Đã liên kết tài khoản với Facebook</span>
                  <v-icon color="green">check</v-icon>
                </v-chip>
                <v-btn class="btn-link" depressed href="" :loading="loadingFacebook" @click="linkToFacebookUser" v-else>
                  <img src="/static/icons/icon-facebook.png" class="btn-icon">
                  <span class="pl-2">Liên kết tài khoản với Facebook</span>
                </v-btn>
                
                <v-chip class="btn-link justify-center" color="grey lighten-4" label depressed @click="openDialogConfirmCancel('zalo')" v-if="linkZalo">
                  <img src="/static/icons/icon-zalo.png" class="btn-icon">
                  <span class="pl-2 pr-2 text-uppercase body-2">Đã liên kết tài khoản với Zalo</span>
                  <v-icon color="green">check</v-icon>
                </v-chip>
                <v-btn class="btn-link" depressed href="" @click="requestPermissionUserZalo" :loading="loadingZalo" v-else>
                  <img src="/static/icons/icon-zalo.png" class="btn-icon">
                  <span class="pl-2">Liên kết tài khoản với Zalo</span>
                </v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-flex>
    <div class="text-xs-center">
      <v-dialog v-model="changePasswordDialog" width="500">
        <v-card>
          <v-toolbar card prominent color="grey lighten-3">
            <v-toolbar-title>Đổi mật khẩu</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="changePasswordDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <change-password/>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <DialogConfirmNotify ref="dialogConfirm" :description="cancelDescription" @confirm="handleCancelThirdParty" :loading="loadingConfirm"/>
  </div>
</template>

<script>
import ChangePassword from './components/changepassword';
import DialogConfirmNotify from '@/components/DialogConfirmNotify';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import validate from '@/utils/validate';
import * as Utils from '@/utils/index';
import * as Auth from '@/utils/auth';

export default {
  name: 'account-infomation',
  components: {
    ChangePassword,
    DialogConfirmNotify
  },
  data () {
    return {
      formValid: false,
      validate: validate,
      isEdit: false,
      isLoading: false,
      changePasswordDialog: false,
      form: {
        name: '',
        phone: '',
        email: '',
        address: ''
      },
      linkFacebook: false,
      linkGoogle: false,
      linkZalo: false,
      loadingFacebook: false,
      loadingGoogle: false,
      loadingZalo: false,
      
      authGoogle: null,
      cancelDescription: '',
      cancelType: '',
      loadingConfirm: false
    };
  },
  computed: {
    ...mapGetters(['loggedUser'])
  },
  watch: {
    loggedUser () {
      this.bindLoggedUser();
    }
  },
  created () {
    this.bindLoggedUser();
    this.linkToZaloUser();
  },

  mounted () {
    this.initSigninFacebook();
    this.initSignInGoogle();
  },

  methods: {
    ...mapActions(['updateProfile', 'linkToFacebook', 'linkToGoogle', 'linkToZalo', 'cancelThirdParty']),
    ...mapMutations(['SET_LOGGED_USER']),
    bindLoggedUser () {
      if (this.loggedUser) {
        this.form.name = this.loggedUser.name;
        this.form.phone = this.loggedUser.phone;
        this.form.email = this.loggedUser.email;
        this.form.address = this.loggedUser.address;
        this.linkFacebook = this.loggedUser.linkFacebook;
        this.linkGoogle = this.loggedUser.linkGoogle;
        this.linkZalo = this.loggedUser.linkZalo;
      }
    },
    submit () {
      if (this.formValid) {
        this.isLoading = true;
        this.updateProfile(this.form)
          .then(_ => {
            window.getApp.showMessage('Cập nhật thành công');
            this.isLoading = false;
            let user = Object.assign({}, this.loggedUser);
            user.name = this.form.name;
            user.email = this.form.email;
            user.address = this.form.address;

            this.SET_LOGGED_USER(user);
            this.isEdit = false;
            this.close();
          })
          .catch(_ => {
            window.getApp.showMessage('Cập nhật thất bại', 'error');
          });
      }
    },
    logout () {
      window.getApp.$emit('APP_LOGOUT');
    },
    close () {
      this.$emit('show', false);
    },

    initSignInGoogle () {
      window.gapi.load('auth2', () => {
      // Retrieve the singleton for the GoogleAuth library and set up the client.
        this.authGoogle = window.gapi.auth2.init({
          client_id: `${Utils.ClientIdOAuth2}.apps.googleusercontent.com`,
          cookiepolicy: 'single_host_origin',
        // Request scopes in addition to 'profile' and 'email'
        // scope: 'additional_scope'
        });

        let element = document.getElementById('signInGoogle');
        if (!element) return;
        // Trả về kết quả khi đăng nhập account google thành công
        this.authGoogle.attachClickHandler(element, {}, (googleUser) => {
          let accessToken = googleUser.getAuthResponse(true).access_token;
          
          // Liên kết với tài khoản google trả về
          this.loadingGoogle = true;
          this.linkToGoogle({ accessToken }).then(res => {
            let user = Object.assign({}, this.loggedUser);
            user.linkGoogle = true;
            this.SET_LOGGED_USER(user);
            this.loadingGoogle = false;
            window.getApp.showMessage('Liên kết thành công!');

          }).catch(err => {
            console.log('initSignInGoogle -> err', err);
            this.loadingGoogle = false;
            return err;
          });
        }, function (error) {
          console.log('initSignInGoogle -> error', error);
          // alert(JSON.stringify(error, undefined, 2));
          window.getApp.showMessage('Liên kết thất bại!', 'error');
        });
      });
    },

    initSigninFacebook () {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: Utils.AppIdFacebook,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v8.0'
        });

        // This function should be here, inside window.fbAsyncInit
        window.FB.getLoginStatus(function (response) {
          // console.log('window.fbAsyncInit -> response', response);
        });
      };

      (function (d, s, id) {
        let js; 
        let fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return }
        js = d.createElement(s); js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    },

    linkToFacebookUser () {
      window.FB.login((response) => {
        console.log('signInFacebook -> response', response);
        this.loadingFacebook = true;
        this.linkToFacebook({ accessToken: response.authResponse && response.authResponse.accessToken }).then(res => {

          let user = Object.assign({}, this.loggedUser);
          user.linkFacebook = true;
          this.SET_LOGGED_USER(user);
          this.loadingFacebook = false;
          
          window.getApp.showMessage('Liên kết thành công!');
        }).catch(err => {
          console.log('linkToFacebookUser -> err', err);
          this.loadingFacebook = false;
          window.getApp.showMessage('Liên kết thất bại!', 'error');
        });
      });
    },

    // Yêu cầu cấp quyền cho User Zalo
    requestPermissionUserZalo () {
      let encodeLink = 'https%3A%2F%2Fweb.motrak.vn';
      window.location.href = `https://oauth.zaloapp.com/v3/permission?app_id=${Utils.AppIdZalo}&redirect_uri=${encodeLink}&state=true`;
    },

    async linkToZaloUser () {
      if (Auth.getCodeZaloUser() && this.loggedUser) {
        // Lấy oAuthCode user zalo đã lưu khi yêu cầu cấp quyền cho User Zalo trả về
        let oAuthCode = Auth.getCodeZaloUser();
        this.loadingZalo = true;
        await this.linkToZalo({ oAuthCode }).then(_ => {
          let user = Object.assign({}, this.loggedUser);
          user.linkZalo = true;
          this.SET_LOGGED_USER(user);
          Auth.removeCodeZaloUser();
          this.loadingZalo = false;
          window.getApp.showMessage('Liên kết thành công!');
        }).catch(err => {
          console.log('linkToZaloUser -> err', err);
          Auth.removeCodeZaloUser();
          this.loadingZalo = false;
          window.getApp.showMessage('Liên kết thất bại!', 'error');
        });
      }
    },

    openDialogConfirmCancel (type) {
      this.cancelType = type;
      let description = 'Bạn có muốn hủy liên kết';
      switch (this.cancelType) {
        case 'google': {
          this.cancelDescription = `${description} tài khoản Google?`;
          break;
        }
        case 'facebook': {
          this.cancelDescription = `${description} tài khoản Facebook?`;
          break;
        }
        case 'zalo': {
          this.cancelDescription = `${description} tài khoản Zalo?`;
          break;
        }
        default: break;
      }
      this.$refs.dialogConfirm.open();
    },

    async handleCancelThirdParty () {
      this.loadingConfirm = true;      
      let res = await this.cancelThirdParty({ type: this.cancelType }).catch(_ => {
        window.getApp.showMessage('Hủy liên kết thất bại!', 'error');
        return false;
      });
      this.loadingConfirm = false;      

      if (res) {
        let user = Object.assign({}, this.loggedUser);
        switch (this.cancelType) {
          case 'google': {
            user.linkGoogle = false;
            break;
          }
          case 'facebook': {
            user.linkFacebook = false;
            break;
          }
          case 'zalo': {
            user.linkZalo = false;
            break;
          }
          default: break;
        }
        this.SET_LOGGED_USER(user);
        window.getApp.showMessage('Hủy liên kết thành công!', 'success');
        this.$refs.dialogConfirm.close();
      }
    }
  }
};
</script>


<style scoped>
.form-content {
  padding: 20px;
}
.btn-icon{
  height: 19px;
  width: 19px;
}
.btn-link{
  max-width: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/index.vue